import { Progress as AntdProgress, ProgressProps } from 'antd';
import React from 'react';
import styled from 'styled-components';

const StyledProgress = styled(AntdProgress)`
  .ant-progress-inner,
  .ant-progress-success-bg,
  .ant-progress-bg {
    border-radius: 0;
  }

  .ant-progress-success-bg {
    background: var(--green-50);
  }

  .ant-progress-inner {
    background: var(--coolest-gray-20);
  }
`;

/* eslint-disable react/jsx-props-no-spreading */
export const Progress: React.FC<ProgressProps> = (props) => {
  return <StyledProgress {...props} />;
};
